var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('a',{attrs:{"target":"_blank","href":"#"}},[_vm._v("版权所有：全国认证认可信息公示平台")]),_c('span',[_vm._v("服务邮箱：service@rzgs.net")])])
}]

export { render, staticRenderFns }